import { Link, useLocation } from "react-router-dom";
import { SITE } from "../data/site";

export default function StickyCallBar() {
    const loc = useLocation();
    if (loc.pathname === "/devis") return null;
    return (
        <div
            className="sm:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-linew grid grid-cols-2 divide-x divide-linew"
            data-testid="sticky-call-bar"
        >
            <a
                href={SITE.phoneHref}
                className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-ivory active:bg-white/5"
                data-testid="sticky-bar-call"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                Appeler
            </a>
            <Link
                to="/devis"
                className="flex items-center justify-center py-4 text-sm font-bold bg-gold text-ink"
                data-testid="sticky-bar-devis"
            >
                Devis gratuit
            </Link>
        </div>
    );
}
